// eslint-disable-next-line @typescript-eslint/naming-convention
export const HIRED_RESIGN = {
  chart: {
    height: 350,
    type: "line",
    stacked: false
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    width: [1, 1, 4]
  },
  yaxis: [
    {
      axisTicks: {
        show: true
      },
      axisBorder: {
        show: true,
        color: "#ff6600"
      },
      labels: {
        style: {
          color: "#ff6600"
        }
      },
      tooltip: {
        enabled: true
      }
    }
  ],
  tooltip: {
    fixed: {
      enabled: true,
      position: "topLeft",
      offsetY: 0,
      offsetX: 60
    }
  },
  legend: {
    show: true,
    markers: {
      radius: 12
    }
  }
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const STATE_TICKET = {
  chart: {
    height: 290,
    type: "radialBar",
    sparkline: {
      enabled: false
    }
  },
  plotOptions: {
    radialBar: {
      offsetY: 20,
      startAngle: -150,
      endAngle: 150,
      hollow: {
        size: "65%"
      },
      track: {
        background: "transparent",
        strokeWidth: "100%"
      },
      dataLabels: {
        name: {
          offsetY: -5,
          color: "#6e6b7b",
          fontSize: "1rem"
        },
        value: {
          offsetY: 15,
          color: "#6e6b7b",
          fontSize: "1.714rem"
        }
      }
    }
  },
  colors: ["#ff6600"],
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "horizontal",
      shadeIntensity: 0.5,
      gradientToColors: ["#9821cf"],
      inverseColors: true,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 100]
    }
  },
  stroke: {
    dashArray: 8
  }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const REVENUE_REPORT = {
  title: {
    text: "Andamento marginalità",
    align: "left",
    style: {
      fontWeight: 600,
      color: "#6e6b7b",
      fontFamily: "Montserrat"
    }
  },
  chart: {
    height: 350,
    stacked: true,
    type: "bar",
    toolbar: { show: false }
  },
  plotOptions: {
    bar: {
      columnWidth: "17%",
      endingShape: "rounded"
    }
  },
  colors: ["#ff6600", "#6e6b7b"],
  dataLabels: {
    enabled: false
  },
  legend: {
    show: true,
    offsetY: 8,
    markers: {
      radius: 12
    }
  },
  grid: {
    padding: {
      top: -20,
      bottom: -10
    },
    yaxis: {
      lines: { show: false }
    }
  },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    labels: {
      style: {
        colors: "#6e6b7b",
        fontSize: "0.86rem"
      }
    },
    axisTicks: {
      show: false
    },
    axisBorder: {
      show: false
    }
  },
  yaxis: {
    labels: {
      style: {
        colors: "#6e6b7b",
        fontSize: "0.86rem"
      }
    }
  }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const BUDGET = {
  chart: {
    height: 80,
    toolbar: { show: false },
    zoom: { enabled: false },
    type: "line",
    sparkline: { enabled: true }
  },
  stroke: {
    curve: "smooth",
    dashArray: [0, 5],
    width: [2]
  },
  colors: ["#ff6600", "#6e6b7b"],
  tooltip: {
    enabled: false
  }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SKILLS = {
  chart: {
    height: 350,
    type: "bubble"
  },
  dataLabels: {
    enabled: false
  },
  fill: {
    opacity: 0.8
  },
  xaxis: {
    label: "Persone"
  },
  legend: {
    show: true
  }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CANDIDATES_FOR_RECRUITERS = {
  chart: {
    type: "bar",
    height: 350
  },
  plotOptions: {
    bar: {
      horizontal: true
    }
  },
  dataLabels: {
    enabled: false
  },
  colors: ["#ff6600"]
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CANDIDATES_OK_KO = {
  chart: {
    height: 350,
    type: "radialBar"
  },
  legend: {
    show: true
  },
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          fontSize: "22px"
        },
        value: {
          fontSize: "16px"
        },
        total: {
          show: true,
          label: "Totale",
          formatter: function() {
            return "122";
          }
        }
      }
    }
  }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SALES_COSTS = {
  chart: {
    height: 350,
    type: "line",
    stacked: false
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    width: [1, 1, 1]
  },
  yaxis: [
    {
      axisTicks: {
        show: true
      },
      axisBorder: {
        show: true,
        color: "#ff6600"
      },
      labels: {
        style: {
          color: "#ff6600"
        },
        formatter: (value: any) => {
          if(value === 0){
            return 0
          }
          if(value.toString().substr(-3) == '000'){
            return (value / 1000).toFixed(0) + "k"
          }
          return (value / 1000).toFixed(3) + "€"
        }
      },
      tooltip: {
        enabled: true
      }
    }
  ],
  tooltip: {
    fixed: {
      enabled: true,
      position: "topLeft",
      offsetY: 30,
      offsetX: 60
    }
  },
  legend: {
    offsetX: 0,
    itemMargin: {
      horizontal: 20,
      vertical: 15
    }
  }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const EDGE_FOR_CLIENTS = {
  chart: {
    type: "bar",
    height: 350
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "55%",
      endingShape: "rounded"
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"]
  },
  yaxis: {
    title: {
      text: "EURO"
    },
    labels: {
      formatter: function(val) {
        return val ? val.toLocaleString("it-IT", { style: "currency", currency: "EUR" }) : "-";
      }
    }
  },
  fill: {
    opacity: 1
  },
  tooltip: {
    y: {
      formatter: function(val) {
        return val ? val.toLocaleString("it-IT", { style: "currency", currency: "EUR" }) : "-";
      }
    }
  },
  legend: {
    show: true,
    markers: {
      radius: 12
    }
  }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CHART_PIE = {
  chart: {
    width: 380,
    type: "pie"
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: "bottom"
        }
      }
    }
  ]
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const NEGOTIATION = {
  chart: {
    type: "donut",
    height: 350
  }
};
  